import { deepMerge } from "../../../../../core/helpers/object-util.js";
import {
	getNumberFormatForDataCell,
	getStyleForHeaderColumn,
	getStyleForPropertiesColumn,
	getSummaryStyleForDepth,
	getTitleStyleForDepth,
	summaryTitleStyle,
} from "./excelStyles.js";

const number = "n";
const string = "s";

/**
 * Todo: Add JSDoc comment
 */
export function makeHeaderCellForColumn({ column, content }) {
	return makeCell({
		content,
		style: getStyleForHeaderColumn({ column }),
	});
}

/**
 * Todo: Add JSDoc comment
 */
export function makePropertiesCellForColumn({ column, content }) {
	return makeCell({
		content,
		style: getStyleForPropertiesColumn({ column }),
	});
}

/**
 * Todo: Add JSDoc comment
 */
export function makeTitleCellForRow({ row, content }) {
	return makeCell({
		content,
		style: getTitleStyleForDepth({ row }),
	});
}

/**
 * Todo: Add JSDoc comment
 */
export function makeSummaryTitleCellForRow({ row, content }) {
	return makeCell({
		content: content.toString(),
		style: deepMerge(summaryTitleStyle, getSummaryStyleForDepth({ row })),
	});
}

/**
 * Todo: Add JSDoc comment
 */
export function makeEmptyCell({ style } = {}) {
	const cell = makeCell({ content: "", type: string, style });
	cell.isEmpty = true;
	return cell;
}

/**
 * Todo: Add JSDoc comment
 */
export function makeNumberCell({ row, column, content, style }) {
	const cell = makeCell({ content, type: number, style });

	cell.z = getNumberFormatForDataCell({ row, column });

	return cell;
}

/**
 * Todo: Add JSDoc comment
 */
export function makeTextCell({ content, style }) {
	return makeCell({ content, type: string, style });
}

function makeCell({ content, type = string, style = {} }) {
	return {
		v: content,
		t: type,
		s: style,
	};
}
